import PageKites from './PageKites';

export default PageKites;
